import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { hideModal } from '../../../../actions/modal';
import { pauseHomework } from '../../../../actions/status';
import { printTime } from '../../../../lib/utils';
import { PAUSE } from '../../../../constants/routes';
import { useOnlineStatus } from '../../../../lib/hooks';
import Spacer from '../../../spacer';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';

export const Message = styled.span``;
export const LeftTime = styled.span``;
export const LeftTimeValue = styled.span``;

export const InitialTime = styled.span`
    font-style: italic;
`;

export const PauseModalBody = ({ onClose, pauseHomework, status, saveStatus, initialTime, leftTime, geogebraMacroList }) => {
    const history = useNavigate();
    const onlineStatus = useOnlineStatus();
    const formattedLeftTime = printTime(leftTime);
    const formattedInitialTime = printTime(initialTime);

    const hasGeogebraModified = geogebraMacroList.some((e) => e);

    const onPause = () => {
        pauseHomework(status, saveStatus);
        onClose();
        setTimeout(history, 0, PAUSE, { replace: true });
    };

    const message = "Potrai riprendere la prova in qualsiasi momento: ricomincerai dall'ultimo esercizio in cui l'hai lasciata.";
    const geogebraMessage = 'Attenzione, scegliendo di interrompere la prova, il lavoro svolto sulle macro Geogebra verrà perso.';

    return (
        <Modal title="Vuoi mettere in pausa?" onClose={onClose}>
            <ModalBodyContainer>
                <Content>
                    <Message className="body-3">{message}</Message>
                    {hasGeogebraModified && (
                        <>
                            <Spacer size="small" />
                            <Message className="body-3">{geogebraMessage}</Message>
                        </>
                    )}

                    {initialTime ? (
                        <>
                            <Spacer size="small" />
                            <>
                                <LeftTime className="body-3">
                                    {'Tempo rimasto: '}
                                    <LeftTimeValue className="body-3-sb">{formattedLeftTime}</LeftTimeValue>
                                </LeftTime>
                            </>
                            <Spacer size="small" />
                            <InitialTime className="body-5">{`Tempo iniziale: ${formattedInitialTime}`}</InitialTime>
                        </>
                    ) : null}
                </Content>
                <Buttons
                    primaryButtonClick={onPause}
                    primaryButtonDisabled={!onlineStatus}
                    primaryButtonText="Metti in pausa"
                    tertiaryButtonClick={onClose}
                    tertiaryButtonText="Torna agli esercizi"
                />
            </ModalBodyContainer>
        </Modal>
    );
};

PauseModalBody.propTypes = {
    onClose: PropTypes.func,
    pauseHomework: PropTypes.func,
    leftTime: PropTypes.number,
    initialTime: PropTypes.number,
    status: PropTypes.object,
    saveStatus: PropTypes.bool,
    geogebraMacroList: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        leftTime: state.status.remainingTime,
        initialTime: state.application.time,
        status: state.status,
        saveStatus: state.application.saveStatus,
        geogebraMacroList: state.homework.geogebraExercises,
    };
};

const actionCreators = {
    onClose: hideModal,
    pauseHomework: pauseHomework,
};

export default connect(mapStateToProps, actionCreators)(PauseModalBody);
